import { Controller } from "@hotwired/stimulus";
import StimulusReflex from "stimulus_reflex";

export default class extends Controller {
  static targets = ["input", "results", "selectedId"];

  connect() {
    StimulusReflex.register(this);
  }

  search() {
    const query = this.inputTarget.value.trim();
    if (query.length < 2) {
      this.resultsTarget.classList.add("hidden");
      return;
    }

    // Set the query in the dataset for the reflex to access
    this.element.dataset.query = query;

    // Give the results div a unique ID based on this controller instance
    const uniqueId = `country-results-${Date.now()}`;
    this.resultsTarget.id = uniqueId;
    this.element.dataset.resultsId = uniqueId;

    // Trigger the reflex
    this.stimulate("CountrySearch#search");
  }

  // Reflex lifecycle methods
  beforeSearch() {
    this.resultsTarget.classList.add("opacity-50");
  }

  searchSuccess() {
    this.resultsTarget.classList.remove("opacity-50");
    this.resultsTarget.classList.remove("hidden");
  }

  searchError(error) {
    console.error("Country search error:", error);
    this.resultsTarget.classList.remove("opacity-50");
    this.resultsTarget.classList.add("hidden");
  }

  select(event) {
    const countryId = event.currentTarget.dataset.countryId;
    const countryName = event.currentTarget.dataset.countryName;

    this.selectedIdTarget.value = countryId;
    this.inputTarget.value = countryName;
    this.resultsTarget.classList.add("hidden");

    // Trigger change event for form validation
    this.inputTarget.dispatchEvent(new Event("change"));

    // Dispatch custom event for subdivision to listen to
    document.dispatchEvent(
      new CustomEvent("countrySelected", {
        detail: { countryId: countryId, countryName: countryName },
      }),
    );
  }

  hideResults() {
    this.resultsTarget.classList.add("hidden");
  }
}
